<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-[20px]">
    <div class="bg-white rounded-lg shadow-lg w-full md:w-[1000px]">
      <!-- Header -->
      <div
        class="rounded-t-lg flex justify-between items-center py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
      >
        <span class="PC_Body2-R text-[#FCFCFC]">
          รายชื่อศูนย์พักพิงที่ต้องการรับการช่วยเหลือ
        </span>
        <CloseIcon
          @click="$emit('close')"
          class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
        />
      </div>

      <!-- <div
        class="bg-primary rounded-t-lg px-6 py-3 flex justify-between items-center h-[48px]"
      >
        <span class="text-white s !text-[14px]"
          >รายชื่อศูนย์พักพิงที่ต้องการรับการช่วยเหลือ</span
        >
        <button
          @click="$emit('close')"
          class="text-primary bg-white rounded-full text-2xl leading-none p-2 hover:text-gray-200"
        >
          <XmarkIcon class="w-2.5 h-2.5 text-primary" color="#9B237B" />
        </button>
      </div> -->

      <!-- Content -->
      <div
        class="p-[20px] flex flex-col h-auto"
        style="max-height: 90vh; overflow-y: auto"
      >
        <!-- <div>{{ data?.data?.product_id }}</div> -->
        <!-- <div>=========================================================</div> -->
        <!-- <div>{{ dataProduct }}</div> -->

        <div class="border border-[#B7B2B5] rounded-[6px] p-[10px]">
          <div class="relative flex gap-[10px]">
            <div class="border border-[#F2E7F9] h-[48px] w-[48px]">
              <img
                :src="data?.data?.image_path"
                alt="Card Image"
                class="min-h-[48px] min-w-[48px] border border-[#DFDCDD]"
              />
            </div>
            <!-- {{ data?.data }} -->
            <div class="h-[72px] flex flex-col items-start gap-[4px]">
              <div class="text-[#1F1D1F]">
                {{ data?.data?.name || "ไม่มีข้อมูล" }}
              </div>
              <div class="text-[#7C7379] label-L !text-[13px]">
                {{ data?.data?.unit_name }}
              </div>
              <div class="text-[#7C7379] label-L !text-[13px]">
                {{ data?.data?.category_name }}
              </div>
            </div>
          </div>
          <!-- {{ data.data }} -->
          <div
            class="w-full mt-[10px] bg-[#EECCE7] rounded-full h-[4px]"
            :class="data?.data?.needed === 'ไม่จำกัด' ? '!bg-[#F3F2F2]' : 'bg-[#9B237B]'"
          >
            <div
              class="bg-[#9B237B] h-[4px] rounded-full"
              :style="{ width: calculateProgressWidth(data.data) }"
            ></div>
          </div>
          <div
            class="text-[#9B237B] bg-[#FBEFF8] mt-[10px] px-[4px] PC_Body2-R h-[29px] content-center"
          >
            ต้องการอีก :
            {{
              data?.data?.needed === "-1" ? "ไม่จำกัด" : formatNumber(data?.data?.needed)
            }}
          </div>
          <div :class="['text-[#1F1D1F] label-L text-right !text-[13px]']">
            <div>ยอดร้องขอ : {{ formatNumber(data?.data?.total_request) }}</div>
            <!-- :class="{ invisible: data?.data?.needed === 'ไม่จำกัด' }" -->
            <div>ยอดที่ได้รับ : {{ formatNumber(data?.data?.total_quantity) }}</div>
          </div>
          <div class="h-[1px] w-full bg-[#DFDCDD] my-[10px]"></div>
          <div class="label-L flex justify-between">
            <div>อัปเดตเมื่อ {{ formatDateToThai(data?.data?.updated_at) }}</div>
            <div>{{ formatTime(data?.data?.updated_at) }}</div>
          </div>
        </div>

        <div>
          <SearchBox
            id="search1"
            placeholder="ค้นหา ชื่อศูนย์พักพิง"
            class="w-full h-[42px] my-[10px]"
            v-model="selectedValue"
            @update:modelValue="handleSearch($event)"
          />
        </div>

        <div class="w-full overflow-x-auto">
          <table class="w-full min-w-[920px] md:min-w-0 table-auto border-collapse">
            <thead>
              <tr>
                <th
                  class="md:w-[100px] text-left py-[16px] px-[10px] bg-primary text-white rounded-tl-[6px] border-r border-white PC_Body2-R whitespace-nowrap"
                >
                  วันที่ร้องขอ
                </th>
                <th
                  class="md:w-[80px] text-left py-[16px] px-[10px] bg-primary text-white border-r border-white PC_Body2-R whitespace-nowrap"
                >
                  เวลา
                </th>
                <th
                  class="text-left py-[16px] px-[10px] bg-primary text-white border-r border-white PC_Body2-R"
                >
                  ชื่อศูนย์พักพิง
                </th>

                <!-- ซ่อนคอลัมน์ “ยอดที่ต้องการอีก” บนจอเล็ก -->
                <th
                  class="text-left py-[16px] px-[10px] bg-primary text-white border-r border-white PC_Body2-R hidden sm:table-cell"
                >
                  ยอดที่ต้องการอีก
                </th>

                <th
                  class="text-left py-[16px] px-[10px] bg-primary text-white border-r border-white PC_Body2-R"
                >
                  ยอดที่ได้รับ/ยอดที่ร้องขอ
                </th>

                <!-- ซ่อน “เบอร์สำหรับติดต่อ” บนจอเล็ก -->
                <th
                  class="text-center px-[10px] bg-primary text-white border-r border-white PC_Body2-R hidden sm:table-cell"
                >
                  เบอร์สำหรับติดต่อ
                </th>

                <th
                  class="text-left md:w-[210px] py-[16px] px-[10px] bg-primary text-white rounded-tr-[6px] border-r border-white PC_Body2-R"
                ></th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(row, index) in dataProduct"
                :key="index"
                :class="['!border-none', { 'bg-[#FBEFF8]': (index + 1) % 2 === 0 }]"
              >
                <td
                  class="text-center !border-none text-sm whitespace-nowrap"
                  :class="index === dataProduct.length - 1 ? 'rounded-bl-[6px]' : ''"
                >
                  {{ formatDateToThai(row.created_at) }}
                </td>

                <td class="p-[10px] !border-none text-sm whitespace-nowrap">
                  {{ formatTime(row.created_at) }}
                </td>

                <!-- จำกัดความกว้าง + ตัด ... บนชื่อยาวๆ -->
                <td
                  class="p-[10px] !border-none text-sm max-w-[220px] md:max-w-none truncate"
                >
                  {{ row.name }}
                </td>

                <!-- คอลัมน์นี้โชว์เฉพาะ ≥ sm -->
                <td class="p-[10px] !border-none text-sm hidden sm:table-cell">
                  {{
                    row.needed == -1 ? "ไม่จำกัด" : (+row.needed).toLocaleString("th-TH")
                  }}
                </td>

                <td class="p-[10px] !border-none text-sm whitespace-nowrap">
                  {{ Number(row.quantity || 0).toLocaleString() }}/
                  {{
                    isNaN(Number(row.request))
                      ? row.request
                      : Number(row.request || 0).toLocaleString()
                  }}
                </td>

                <!-- คอลัมน์นี้โชว์เฉพาะ ≥ sm -->
                <td class="p-[10px] !border-none text-sm hidden sm:table-cell">
                  {{ row.phone }}
                </td>

                <td
                  class="p-[10px] !border-none"
                  :class="index === dataProduct.length - 1 ? 'rounded-br-[6px]' : ''"
                >
                  <!-- {{ row?.shelter_has }} -->
                  <div class="flex justify-center items-center gap-2.5">
                    <button
                      v-if="auth.hasRole([ROLES.admin]) || auth.hasRole([ROLES.staff])"
                      :disabled="row?.shelter_has == 0 || (auth.userData.role && (row.shelter_id == auth?.userData?.shelter_id))"
                      @click="transfer(data?.data, row?.id, row?.shelter_id)"
                      class="group flex items-center justify-center gap-1.5 h-[36px] bg-white border border-secondary-heavy px-3 rounded-[6px] duration-300 cursor-pointer hover:bg-white/60 disabled:bg-[#FFF] disabled:border-[#DFDCDD] disabled:!cursor-default"
                    >
                      <span
                        class="text-[#1F1D1F] s flex gap-[4px] items-center group-disabled:text-[#DFDCDD]"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          class="text-[#9B237B] group-disabled:text-[#DFDCDD]"
                        >
                          <path
                            d="M5.02282 4.35355C5.21809 4.15829 5.21809 3.84171 5.02282 3.64645C4.82756 3.45118 4.51098 3.45118 4.31572 3.64645L2.98238 4.97978C2.78712 5.17504 2.78712 5.49162 2.98238 5.68689L4.31572 7.02022C4.51098 7.21548 4.82756 7.21548 5.02282 7.02022C5.21809 6.82496 5.21809 6.50838 5.02282 6.31311L4.54304 5.83333H11.3359C11.6121 5.83333 11.8359 5.60948 11.8359 5.33333C11.8359 5.05719 11.6121 4.83333 11.3359 4.83333H4.54304L5.02282 4.35355Z"
                            fill="currentColor"
                          />
                          <path
                            d="M10.9824 8.97978C10.7871 9.17504 10.7871 9.49163 10.9824 9.68689L11.4622 10.1667H4.66927C4.39313 10.1667 4.16927 10.3905 4.16927 10.6667C4.16927 10.9428 4.39313 11.1667 4.66927 11.1667H11.4622L10.9824 11.6464C10.7871 11.8417 10.7871 12.1583 10.9824 12.3536C11.1776 12.5488 11.4942 12.5488 11.6895 12.3536L13.0228 11.0202C13.2181 10.825 13.2181 10.5084 13.0228 10.3131L11.6895 8.97978C11.4942 8.78452 11.1776 8.78452 10.9824 8.97978Z"
                            fill="currentColor"
                          />
                        </svg>

                        ส่งมอบทรัพยากร
                      </span>
                    </button>

                    <button
                      @click="showShelter(row.shelter_id, row.id)"
                      class="group w-[36px] h-[36px] justify-items-center bg-white inline-block border border-secondary-heavy p-1.5 rounded-[6px] duration-300 cursor-pointer hover:bg-white/60"
                    >
                      <InfoIcon class="text-primary" />
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="dataProduct.length <= 0">
                <td colspan="10">
                  <div
                    class="flex flex-col justify-center items-center gap-[9px] py-[40px] px-[20px] text-[#8D8D8D]"
                  >
                    <EmergencyReqIcon class="w-15 h-15" />
                    <span>ขณะนี้ยังไม่มีข้อมูล</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-[10px]">
          <PaginationComponent :items="itemsTable" @selectedPage="handlePage" />
        </div>
      </div>
    </div>

    <!-- Modals -->
    <ShelterInfoModal
      v-if="showShelterInfo"
      :shelter="shelterData"
      :manage="true"
      @close="showShelterInfo = false"
    />
    <TransferResourceSpecialModal
      ref="TransferResourceModalRef"
      @status="handleSuccess"
    />
    <StatusModal ref="statusModal" />
    <!-- @submit="checkAction" -->
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Radio from "../Utilities/Radio.vue";
import ShelterInfoModal from "../Modals/ShelterInfoModal.vue";
import { useRequestHelpStore } from "@/pinia/requestHelp";
import { useAppointmentRequestStore } from "@/pinia/appointmentStore";
import { ROLES } from "@/components/Utilities/javascripts/permissions";
import { useAuthStore } from "@/pinia/authStore";
import "@/pinia/echo";

const router = useRouter();
const route = useRoute();
const auth = useAuthStore();

const requestHelpStore = useRequestHelpStore();
const appointmentRequestStore = useAppointmentRequestStore();

const emit = defineEmits(["close"]);

const props = defineProps({
  data: {
    type: Object,
    required: true,
    default: () => ({
      image: "",
      name: "",
    }),
  },
});

const showShelterInfo = ref(false);
const dataProduct = ref([]); // <- เก็บ rows จาก API
const loading = ref(false);
const apiError = ref(null);
const TransferResourceModalRef = ref(null);
const statusModal = ref(null);

const input = {
  nameProvince: "เชียงราย",
  type: "",
  level: "",
  notify: null,
};
const form = ref({ ...input });
const errors = ref({ ...input });

const selectedValue = ref("");

let searchTimer = null;

const shelterData = ref({
  image: "",
  name: "",
  phone: "",
  status: "",
  founded: "",
  leader: "",
  units: "",
  occupancy: "",
});

// สถานะตารางจาก API (ผูกกับ PaginationComponent)
const itemsTable = ref({
  current_page: 1,
  last_page: 1,
  from: 0,
  to: 0,
  total: 0,
  per_page: 10,
});

const filter = ref({
  page: 1,
  search: "",
});

const isFormValid = computed(() => {
  return (
    form.value.nameProvince &&
    form.value.type &&
    form.value.level &&
    form.value.notify !== null
  );
});

function handleSearch(value) {
  selectedValue.value = value ?? "";
  filter.value.search = (value ?? "").trim();
  clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    // เวลาค้นหาให้กลับไปหน้า 1 เสมอ
    getData(1);
  }, 350);
}

// ====== helper แถมให้: progress bar ======
function calculateProgressWidth(card) {
  if (!card?.total_request || Number(card.total_request) === 0) return "0%";
  const current = Number(
    String(card.total_quantity ?? 0)
      .toString()
      .replace(/,/g, "")
  );
  const total = Number(
    String(card.total_request ?? 0)
      .toString()
      .replace(/,/g, "")
  );
  if (isNaN(current) || isNaN(total) || total === 0) return "0%";
  const percentage = (current / total) * 100;
  return percentage.toFixed(2) + "%";
}

// ===== เรียก API =====
async function getData(page = 1) {
  try {
    loading.value = true;
    apiError.value = null;

    const productId =
      typeof props.data === "object"
        ? props.data.data?.product_id ?? props.data.product_id ?? null
        : props.data;

    const s = await requestHelpStore.getProductRequestDBById(productId, {
      pagination: 1,
      page,
      search: filter.value.search || undefined, // ถ้าเป็น '' จะไม่ส่ง
      // per_page: itemsTable.value.per_page,
    });

    const meta = s?.data;
    const rows = meta?.data ?? [];
    // console.log('meta?.data : ', meta?.data);

    dataProduct.value = rows;

    itemsTable.value = {
      current_page: meta?.current_page ?? page,
      last_page: meta?.last_page ?? 1,
      from: meta?.from ?? 0,
      to: meta?.to ?? 0,
      total: meta?.total ?? rows.length,
      per_page: meta?.per_page ?? itemsTable.value.per_page ?? 10,
    };

    filter.value.page = itemsTable.value.current_page;
  } catch (err) {
    console.error("openListShelter error:", err);
    apiError.value = err?.message ?? "เกิดข้อผิดพลาด";
    dataProduct.value = [];
    itemsTable.value = {
      current_page: 1,
      last_page: 1,
      from: 0,
      to: 0,
      total: 0,
      per_page: 10,
    };
  } finally {
    loading.value = false;
  }
}

// เปลี่ยนหน้า -> ยิง getData(page) ใหม่
const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData(page);
};

onMounted(() => {
  getData(1);
  Echo.channel("Product").listen(".page.refresh", (e) => {
    // console.log("Refresh event:", e);
    // action refresh หน้า
    // ออกหลังได้ event
    // getData(1);
    emit("close");
  });
});

onUnmounted(async () => {
  // Echo.leave("Product");
  // Echo.channel("Product").listen(".page.refresh", (e) => {
  //   console.log("Refresh event:", e);
  //   // action refresh หน้า
  //   // ออกหลังได้ event
  //   getData(1);
  // });
});

// ถ้าข้อมูล prop เปลี่ยน (เช่นเปิดโมดัลใหม่ด้วย item อื่น) -> โหลดหน้า 1 ใหม่
watch(
  () => props.data,
  () => getData(1)
);

async function showShelter(id, shelter_log_id) {
  try {
    const apiRes = await appointmentRequestStore.getShelter(id);
    const s = apiRes.data || apiRes;
    // console.log("showShelter", s);

    shelterData.value = {
      image: s.image,
      name: s.name,
      phone: s.phone,
      status: s.status === 1 ? "เปิดใช้งาน" : "ปิดทำการ",
      founded: formatThaiDate(s.created_date),
      leader: s.leader_name || "-",
      units: String(s.staff_count),
      occupancy: `${s.current_capacity} / ${s.max_capacity}`,
      gis_map: s.gis_map,
      google_maps: s.google_maps,
    };
    showShelterInfo.value = true;
  } catch (err) {
    console.error("getShelter failed:", err);
  }
}

function formatThaiDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function formatDateToThai(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear() + 543; // แปลงเป็น พ.ศ.
  return `${day}-${month}-${year}`;
}

function formatTime(dateString) {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

function formatNumber(value) {
  if (value === null || value === undefined) return "-";
  if (isNaN(value)) return value; // ถ้าไม่ใช่ตัวเลข เช่น "ไม่จำกัด" ก็คืนค่าตรง ๆ
  return new Intl.NumberFormat("th-TH").format(value);
}

const handleSuccess = (message, status) => {
  // console.log("success handleSuccess");
  // console.log(message, status);

  statusModal.value.openModal(status, {
    subHeader: message,
  });
};

const transfer = (data, id, shelter_id) => {
  // console.log('wdw',data);
  if (data) {
    TransferResourceModalRef.value.openModal(data, id, shelter_id);
  } else {
    TransferResourceModalRef.value.openModal();
  }
};

watch(
  () => form.value.notify,
  (newVal) => {
    // console.log("เลือก:", newVal);
  }
);
</script>
